<section class="app-empty-state" [class.is-compact]="compact()" [class.is-centered]="centered()">
	<div class="app-empty-state__icon">
		<ng-content select="[appEmptyStateIcon]"></ng-content>
	</div>
	<div class="app-empty-state__content">
		<h3 class="app-empty-state__title">{{ title() }}</h3>
		@if (description()) {
			<p class="app-empty-state__description">{{ description() }}</p>
		}
		<div class="app-empty-state__body">
			<ng-content></ng-content>
		</div>
		<div class="app-empty-state__actions">
			<ng-content select="[appEmptyStateActions]"></ng-content>
		</div>
	</div>
</section>
